import { render, staticRenderFns } from "./ProfileCustomerData.vue?vue&type=template&id=dc1c31ac&"
import script from "./ProfileCustomerData.vue?vue&type=script&lang=js&"
export * from "./ProfileCustomerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports